import z from "zod";

const subscriptionCancelledDataSchema = z.object({
    ip: z.string().nullable(),
    reason: z.string().nullable(),
    chargeId: z.string().nullable(),
});

export { subscriptionCancelledDataSchema };
